module.exports = __webpack_public_path__ + "static/img/modal-error.ac1760e4.png";